import { useClassNames } from '@magnetic/hooks';
import { DeviceStatus, StatusIcon } from '@magnetic/icons';
import React, { forwardRef } from 'react';
import './style.css.js';
import { TagFrame } from '../frame/index.js';

const StatusTag = forwardRef(
  ({ children, className, status, ...props }, ref) => {
    const classNames = useClassNames([
      "mds-rebuild-status-tag",
      `mds-rebuild-tag-status-${status}`,
      "mds-rebuild-tag-compact",
      className
    ]);
    const statusMap = {
      positive: {
        label: "Positive",
        component: /* @__PURE__ */ React.createElement(DeviceStatus, {
          status: "good"
        })
      },
      warning: {
        label: "Warning",
        component: /* @__PURE__ */ React.createElement(DeviceStatus, {
          status: "warning"
        })
      },
      negative: {
        label: "Negative",
        component: /* @__PURE__ */ React.createElement(DeviceStatus, {
          status: "critical"
        })
      },
      inactive: {
        label: "Inactive",
        component: /* @__PURE__ */ React.createElement(DeviceStatus, {
          status: "inactive"
        })
      },
      disabled: {
        label: "Disabled",
        component: /* @__PURE__ */ React.createElement(StatusIcon, {
          status: "disabled"
        })
      }
    };
    return /* @__PURE__ */ React.createElement(TagFrame, {
      ...props,
      className: classNames,
      prefix: statusMap[status].component,
      ref,
      role: "status"
    }, children != null ? children : statusMap[status].label);
  }
);
StatusTag.displayName = "Tag.Status";

export { StatusTag };
//# sourceMappingURL=index.js.map
